import m from "../../geodata/es2015/bosniaHerzegovinaCantonsLow";
window.am4geodata_bosniaHerzegovinaCantonsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bosniaHerzegovinaCantonsLow.js
// module id = null
// module chunks = 